<template>
  <div class="order-details">
    <!-- 订单详情页 -->
    <div class="all-center-box">
      <div class="w-1500">
        <div class="address-box w-100">
          <router-link to="/">首页</router-link> /
          <router-link to="/meOrder">我的订单</router-link> / <a>订单详情</a>
        </div>
        <div class="clearfix"></div>
        <div class="details-main" v-if="afterSale">
          <div class="order-info">
            <div class="left pull-left">
              <h3>订单信息</h3>
              <ul class="list">
                <li class="table-list">
                  <div class="trade-imfor-dt">
                    <span>收货地址：</span>
                  </div>
                  <div class="trade-imfor-dd">
                    <span
                      >{{ orderMsg.orderExt.receiverName }},{{
                        orderMsg.orderExt.receiverPhone
                      }},{{ orderMsg.orderExt.addressDetail }}</span
                    >
                  </div>
                </li>
                <!-- <li class="table-list">
									<div class="trade-imfor-dt">
										<span>买家留言：</span>
									</div>
									<div class="trade-imfor-dd">
										<span>是地方撒发生的</span>
									</div>
								</li> -->
                <li class="table-list">
                  <div class="trade-imfor-dt">
                    <span>订单编号：</span>
                  </div>
                  <div class="trade-imfor-dd">
                    <span>{{ orderMsg.storeOrder.uid }}</span>
                  </div>
                </li>
                <!-- <li class="table-list">
                  <div class="trade-imfor-dt">
                    <span>商家：</span>
                  </div>
                  <div class="trade-imfor-dd">
                    <span>{{ orderMsg.storeOrder.storeName }}</span>
                  </div>
                </li> -->
              </ul>
            </div>
            <div class="right pull-right">
              <div class="box">
                <div class="box-cell">
                  <div class="trade-detail-imfor">
                    <div class="imfor-icon">
                      <img src="../../assets/images/order-gou.png" alt="状态" />
                    </div>
                    <!-- 售后进度 -1未处理 1同意（待买家发货） 2驳回 3买家已发货 4已收货 8卖家已发货 9售后完成 11.韵达上门中  15.售后结束  99.已撤销 -->
                    <div class="imfor-title">
                      <h3>
                        售后进度:
                        {{
                          setStatus(orderMsg.state)
                        }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="shop-status">
            <ul>
              <li class="th">
                <span>商品</span>
                <span>单价</span>
                <span>数量</span>
                <span>优惠</span>
                <span>状态</span>
              </li>
              <li class="tr">
                <div class="first">
                  <img
                    class="item-img"
                    :src="orderMsg.orderStoreGoods.goodsImageUrl"
                    alt="图片"
                  />
                  <div class="item-meta">
                    <p>{{ orderMsg.orderStoreGoods.goodsName }}</p>
                    <p>
                      型号：<em>{{
                        orderMsg.orderStoreGoods.goodsSpecInstName
                          ? orderMsg.orderStoreGoods.goodsSpecInstName
                          : '暂无'
                      }}</em>
                    </p>
                  </div>
                </div>
                <div>￥{{ orderMsg.orderStoreGoods.price }}</div>
                <div>{{ orderMsg.orderStoreGoods.amount }}</div>
                <div>￥0.00</div>
                <div>
                  {{
                    orderMsg.state == -1
                      ? '未处理'
                      : orderMsg.state == 1
                      ? '同意（待买家发货）'
                      : orderMsg.state == 2
                      ? '驳回'
                      : orderMsg.state == 3
                      ? '买家已发货'
                      : orderMsg.state == 4
                      ? '已收货'
                      : orderMsg.state == 8
                      ? '卖家已发货'
                      : orderMsg.state == 9
                      ? '售后完成'
                      : orderMsg.state == 11
                      ? '快递上门中'
                      : orderMsg.state == 15
                      ? '售后结束'
                      : '已撤销'
                  }}
                </div>
              </li>
            </ul>
          </div>
          <div class="bottom-info between-top">
            <div class="title-box column-between">
              <span>商品总价：</span>
              <span>运费(快递)：</span>
              <span>运费险(卖家赠送)：</span>
              <span>店铺优惠：</span>
              <span class="sfk">实付款：</span>
            </div>
            <div
              class="price-box column-between"
              v-if="orderMsg.storeOrder.totalPrice"
            >
              <span>￥{{ orderMsg.storeOrder.totalPrice }}</span>
              <span>￥0.00</span>
              <span>￥0.00</span>
              <span>￥0.00</span>
              <span class="sfk">￥{{ orderMsg.storeOrder.totalPrice }}</span>
            </div>
          </div>
        </div>
        <div class="details-main" v-else>
          <div class="order-info">
            <div class="left pull-left">
              <h3>订单信息</h3>
              <ul class="list">
                <li class="table-list">
                  <!-- <div class="trade-imfor-dt">
                    <span>收货地址：</span>
                  </div> -->
                  <!-- <div class="trade-imfor-dd">
                    <span
                      >{{ orderMsg.orderExt.receiverName }},{{
                        orderMsg.orderExt.receiverPhone
                      }},{{ orderMsg.orderExt.addressDetail }}</span
                    >
                  </div> -->
                </li>
                <!-- <li class="table-list">
									<div class="trade-imfor-dt">
										<span>买家留言：</span>
									</div>
									<div class="trade-imfor-dd">
										<span>是地方撒发生的</span>
									</div>
								</li> -->
                <li class="table-list">
                  <div class="trade-imfor-dt">
                    <span>订单编号：</span>
                  </div>
                  <div class="trade-imfor-dd">
                    <span>{{ orderMsg.uid }}</span>
                  </div>
                </li>
                <li class="table-list">
                  <div class="trade-imfor-dt">
                    <span>收件人：</span>
                  </div>
                  <div v-if="orderMsg.orderExt" class="trade-imfor-dd">
                    <span>{{ orderMsg.orderExt.receiverName }}</span>
                  </div>
                </li>
                <li class="table-list">
                  <div class="trade-imfor-dt">
                    <span>联系电话：</span>
                  </div>
                  <div v-if="orderMsg.orderExt" class="trade-imfor-dd">
                    <span>{{ orderMsg.orderExt.receiverPhone }}</span>
                  </div>
                </li>
                <li class="table-list">
                  <div class="trade-imfor-dt">
                    <span>详细地址：</span>
                  </div>
                  <div v-if="orderMsg.orderExt" class="trade-imfor-dd">
                    <span>{{ orderMsg.orderExt.province + orderMsg.orderExt.city + orderMsg.orderExt.county + orderMsg.orderExt.addressDetail }}</span>
                  </div>
                </li>
              </ul>
            </div>
            <div class="right pull-right">
              <div class="box">
                <div class="box-cell">
                  <div class="trade-detail-imfor">
                    <div class="imfor-icon">
                      <img src="../../assets/images/order-gou.png" alt="状态" />
                    </div>
                    <div class="imfor-title">
                      <h3>
                        订单状态:
                        {{
                           setStatus(orderMsg.state)
                        }}
                      </h3>
                    </div>
                  </div>
                  <ul
                    v-if="
                      orderMsg.state == 20 ||
                      orderMsg.state == 25 ||
                      orderMsg.state == 30
                    "
                  >
                    <li class="logistics">
                      <span class="title">物流：</span>
                      <div class="trade-detail-logistic">
                        <span class="package-detail">{{
                          orderMsg.logistics.express.name
                        }}</span>
                        <span class="package-detail"
                          >运单号:{{ orderMsg.logistics.logisticsnum }}</span
                        >
                      </div>
                    </li>
                    <li class="time">
                      <span>{{ orderMsg.logistics.whenCreated }}</span>
                      <span>您已完成取件，期待再次为您服务。</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="shop-status">
            <table ale style="border-collapse: collapse; width: 100%;text-align: center;table-layout: fixed;">
              <thead style="line-height: 28px; font-size: 1.6rem;font-size: 12px;">
                <tr>
                  <th colspan="1" style="font-weight: 500;text-align: center;">商品</th>
                  <th colspan="1" style="font-weight: 500;text-align: center;">数量</th>
                  <th colspan="1" style="font-weight: 500;text-align: center;">状态</th>
                </tr>
              </thead>
              <tbody style="font-size: 12px; white-space: pre-wrap;">
                <tr v-for="(item, index) in orderMsg.orderGoods" :key="index" style="border-top: 1px solid #ececec;cursor: pointer;" @click="clickDetails(item)">
                  <td colspan="1" style="padding: 14px 0;">
                    <div style="display: flex;align-items: center;justify-content: center;">
                      <div style="display: flex;gap: 20px;width: fit-content;">
                        <img
                          style="display: block;width: 50px;height: 50px;margin-left: 25px;"
                          :src="item.goodsCoverUrl"
                          alt="图片"
                        />
                        <div style="text-align: left;display: flex;align-items: flex-start;justify-content: space-around;flex-direction: column;height: 50px;">
                          <div style="font-size: 12px;color: #999;">{{ item.goodsName }}</div>
                          <div style="font-size: 12px;color: #666;text-align: left;">
                            <span>型号：</span>
                            <span style="color: #999;font-size: 12px;">{{ item.specDetail ? item.specDetail : '暂无' }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td colspan="1" style="padding: 14px 0;">
                    <span>x{{ item.quantity }}</span>
                  </td>
                  <td colspan="1" style="padding: 14px 0;">
                    <span>{{ setStatus(orderMsg.state) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>

            <ul v-if="false">
              <li class="th">
                <span>商品</span>
                <!-- <span>单价</span> -->
                <span>数量</span>
                <!-- <span>优惠</span> -->
                <span>状态</span>
              </li>
              <template v-for="(item, index) in orderMsg.orderGoods">
                <li class="tr">
                  <div class="first">
                    <img
                      class="item-img"
                      :src="item.goodsCoverUrl"
                      alt="图片"
                    />
                    <div class="item-meta">
                      <p>{{ item.goodsName }}</p>
                      <p>
                        型号：<em>{{
                          item.specDetail ? item.specDetail : '暂无'
                        }}</em>
                      </p>
                    </div>
                  </div>
                  <!-- <div>￥{{ item.price }}</div> -->
                  <div>x{{ item.quantity }}</div>
                  <!-- <div>￥0.00</div> -->
                  <div>
                    {{
                      setStatus(orderMsg.state)
                    }}
                  </div>
                </li>
              </template>
            </ul>
          </div>
          <div class="bottom-info between-top" v-if="false">
            <div class="title-box column-between">
              <span>商品总价：</span>
              <span>运费(快递)：</span>
              <span>运费险(卖家赠送)：</span>
              <span>店铺优惠：</span>
              <span class="sfk">实付款：</span>
            </div>
            <div class="price-box column-between" v-if="orderMsg.totalAmt">
              <span>￥{{ orderMsg.totalAmt }}</span>
              <span>￥0.00</span>
              <span>￥0.00</span>
              <span>￥0.00</span>
              <span class="sfk">￥{{ orderMsg.totalAmt }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  orderStore,
  aftersale
} from '@/common/http.js';
import { setStatus } from '../../utils/orderStatus';
import { getOrderDetails, getCategories } from '../../common/http';
export default {
  name: 'orderDetails',
  data () {
    return {
      orderMsg: {},
      afterSale: false,
      categorys: []
    }
  },
  mounted() {
    this.initCategory();
    if (this.$route.query.aftersale) {
      this.afterSale = true;
      this.getSaleDetail();
    } else {
      this.afterSale = false;
      this.getDetail(this.$route.query.uid);
    }
  },
  methods: {
    initCategory() {
      getCategories({
        // homeCategoryId: 15,
        // isChildren: 1,
        type: 1
      }).then(res => {
        if (res.result) {
          this.categorys = res.data;
        }
      });
    },
    clickDetails(it) {
      let params = {};
      params.uid = it.uid;
      params.childrenName = it.category.name;
      params.productId = it.category.id;

      // 递归查找所有父级节点
      const findParents = (data, targetId, path = []) => {
        for (const item of data) {
          if (item.id === targetId) {
            return [...path, item];
          }
          if (item.children) {
            const result = findParents(item.children, targetId, [
              ...path,
              item
            ]);
            if (result) {
              return result;
            }
          }
        }
        return null;
      };

      // 查找匹配的节点及其所有父级
      const parents = findParents(this.categorys, params.productId);
      this.$store.commit("SET_CATEGORYDATA", parents);
      const routerJump = this.$router.resolve({
        name: "productTypeScreen",
        path: "/productTypeScreen",
        query: params
      });

      window.open(routerJump.href, "_blank");
    },
    setStatus(status){
      return setStatus(status);
    },
    getDetail (uid) {
      getOrderDetails({
        uid: uid
      }).then(res => {
        if (res.result) {
          this.orderMsg = res.data;
        }
      })
    },
    getSaleDetail () {
      aftersale({
        id: this.$route.query.id
      }).then(res => {
        if (res.result) {
          this.orderMsg = res.data.obj;
        }
      })
    }
  }
}
</script>

<style scoped>
.all-center-box {
  background: #fff;
}
.shop-status{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/userCenter/orderDetails.vue